import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { CalculoCargosEspecialesInput, ConsultaLecturas } from '../../entidades/entidades';

@Component({
  selector: 'app-calculo-cargos-especiales-grid',
  templateUrl: './calculo-cargos-especiales-grid.component.html',
  styleUrls: ['./calculo-cargos-especiales-grid.component.css']
})
export class CalculoCargosEspecialesGridComponent implements OnInit {
  @Input() consultaLectura: any;  
  itemsMenu: MenuItem[];
  columnasTabla: any[];
  cuentaAgua: number;
  tarifa: number;
  cuentas: any[] = [];
  calculoCargosEspecialesInput: CalculoCargosEspecialesInput;
  public usuario: any;
  authenticationService: any;
  
  

  constructor() { }

  async ngOnInit() {
    this.itemsMenu = [
      { label: "Agregar", icon: "pi pi-plus", command: () => this.add(this.cuentaAgua), },
      { label: "Calcular", icon: "pi pi-save", command: () => this.guardaCargosDetalles(),}
    ];
    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore

      this.columnasTabla = [
        { field: "operacion", header: "", ordenar: false, styleHeader: "width: 30px;", },
        { field: "cuentaAgua", header: "Cuenta Agua", ordenar: false, styleHeader: "width: 80px;", },
        { field: "consecutivo", header: "Consecutivo", ordenar: false, styleHeader: "width: 80px;", },
        { field: "consumo", header: "Consumo", ordenar: false, styleHeader: "width: 80px;", },
      ];
      await this.authenticationService.getUserByToken();
      this.usuario = this.authenticationService.currentUserValue.id;
    
  }
  guardaCargosDetalles(): void {
    try {
      this.calculoCargosEspecialesInput = new CalculoCargosEspecialesInput();
      this.calculoCargosEspecialesInput.idAguasJson = [];
      this.calculoCargosEspecialesInput.idUsuarioGuardo  = this.usuario;
      this.calculoCargosEspecialesInput.tarifa = this.tarifa;
      console.log('Cuentas:', this.cuentas);
      this.cuentas.forEach(x => {
        console.log('Cuenta:', x);
        this.calculoCargosEspecialesInput.idAguasJson.push(x.cuenta);
      });

      
    } catch (error) {
      throw error;
    }
  }
  add(cuentaAgua: number): void {
    try {
        console.log('Cuenta de agua:',this.consultaLectura );
        const cuenta = this.consultaLectura.find(x => Number(x.cuenta) === Number(cuentaAgua));
        console.log('Cuenta:', cuenta); 
        
        if(cuenta === undefined)
          throw new Error('No se encontró la cuenta de agua');

        this.cuentas.push(cuenta);
    } catch (error) {
      throw error;
    }
  }
  ngOnChanges() {
    console.log('Datos recibidos en el hijo:', this.consultaLectura);
  }
}
